export default "__VITE_ASSET__C_Ei3FLO__"